const en = {
  worlds: 'Worlds', chooseCategory: 'Choose a Category',
  introduction: 'Choose a subject or learning collection, then explore its worlds at your own pace.',
  exploreWorlds: 'Explore Worlds', backToCategories: 'Back to Categories',
  academicYear: 'Academic Year', otherWorlds: 'Other Worlds',
  noWorlds: 'No Worlds Available', emptyCategory: 'This category has no available worlds yet.',
  notFound: 'Category not found', notFoundDescription: 'This category does not exist in the current catalogue.',
  loadError: 'Worlds could not be loaded. Please try again.',
  partialError: 'Some worlds could not be loaded. Please try again.', retry: 'Try again',
  worldNotFound: 'World not found', worldNotFoundDescription: 'This world is unavailable or its file could not be loaded.',
  backToWorlds: 'Back to Worlds',
  showCategoryDetails: 'Show details', hideCategoryDetails: 'Hide details',
};
const sk: typeof en = {
  worlds: 'Svety', chooseCategory: 'Vyberte kategóriu',
  introduction: 'Vyberte si predmet alebo výučbový celok a postupujte jeho svetmi vlastným tempom.',
  exploreWorlds: 'Preskúmať svety', backToCategories: 'Späť na kategórie',
  academicYear: 'Akademický rok', otherWorlds: 'Ostatné svety',
  noWorlds: 'Žiadne dostupné svety', emptyCategory: 'Táto kategória zatiaľ nemá dostupné svety.',
  notFound: 'Kategória sa nenašla', notFoundDescription: 'Táto kategória v aktuálnom katalógu neexistuje.',
  loadError: 'Svety sa nepodarilo načítať. Skúste to znova.',
  partialError: 'Niektoré svety sa nepodarilo načítať. Skúste to znova.', retry: 'Skúsiť znova',
  worldNotFound: 'Svet sa nenašiel', worldNotFoundDescription: 'Tento svet nie je dostupný alebo sa nepodarilo načítať jeho súbor.',
  backToWorlds: 'Späť na svety',
  showCategoryDetails: 'Zobraziť podrobnosti', hideCategoryDetails: 'Skryť podrobnosti',
};

// Keep the lightweight SK/EN choice used by level resources. The shell uses <html lang="en">.
// No new language setting, persistence or language selector is introduced.
export function getCatalogText(language = typeof document === 'undefined' ? 'en' : document.documentElement.lang) {
  const slovak = language.toLowerCase().split('-')[0] === 'sk';
  return {
    ...(slovak ? sk : en),
    backToCategory: (name: string) => slovak ? `Späť na ${name}` : `Back to ${name}`,
    worldCount: (count: number) => slovak
      ? `${count} ${count === 1 ? 'svet' : count >= 2 && count <= 4 ? 'svety' : 'svetov'}`
      : `${count} ${count === 1 ? 'world' : 'worlds'}`,
  };
}
